"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetricChip = MetricChip;
var _Text = _interopRequireDefault(require("react-native-web/dist/exports/Text"));
var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));
var _UiThemeProvider = require("../theme/UiThemeProvider");
var _color = require("../utils/color");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Small status/metric pill (sensor badges, gain indicators, filters).
 * Tones use a soft wash of the status color — the same treatment as the
 * mobile destructive buttons — so chips never shout over telemetry.
 */
function MetricChip({
  label,
  value,
  tone = 'default',
  style,
  ...rest
}) {
  const theme = (0, _UiThemeProvider.useUiTheme)();
  const toneColor = {
    default: undefined,
    accent: theme.palette.accentSolid,
    success: theme.palette.success,
    warning: theme.palette.warning,
    error: theme.palette.error
  }[tone];
  const backgroundColor = toneColor ? (0, _color.alpha)(toneColor, 0.16) : theme.palette.badgeBackground;
  const textColor = toneColor ?? theme.palette.badgeText;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    ...rest,
    style: [{
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      gap: 4,
      backgroundColor,
      borderRadius: theme.radius.small,
      paddingVertical: 4,
      paddingHorizontal: theme.spacing.sm
    }, style],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      style: {
        fontSize: theme.fontSizes.small,
        fontWeight: '500',
        color: textColor
      },
      children: label
    }), value ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      style: {
        fontSize: theme.fontSizes.small,
        fontWeight: '700',
        color: textColor,
        fontVariant: ['tabular-nums']
      },
      children: value
    }) : null]
  });
}